var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33604 1.18505C2.00153 0.524254 3.08016 0.524254 3.7453 1.18505L11.7764 9.15944L19.8074 1.18505C20.4729 0.524254 21.5516 0.524254 22.2167 1.18505C22.8822 1.84585 22.8822 2.91687 22.2167 3.57732L14.1856 11.5517L22.2167 19.5261C22.8822 20.1869 22.8822 21.2579 22.2167 21.9184C21.5512 22.5791 20.4726 22.5788 19.8074 21.9184L11.7764 13.944L3.7453 21.9184C3.07981 22.5788 2.00118 22.5788 1.33604 21.9184C0.67054 21.2576 0.67054 20.1865 1.33604 19.5261L9.3671 11.5517L1.33604 3.57732C0.67054 2.91652 0.67054 1.8455 1.33604 1.18505Z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/closeModal.367d56b338a71323a1d34fd954201310.svg";
export { ForwardRef as ReactComponent };